export function isDeviceOffline() {
  return 'onLine' in navigator && !navigator.onLine;
}
